/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ClassNames from 'classnames';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

class PackageTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: '/images/no-package-poster.png'
    };
  }

  componentDidMount() {

    this.props.pckage.id && lh.models.asset.methods.getPosterUrl(this.props.pckage, {
      crop: {x: 132, y: 132},
      cache: false
    })
      .then((url) => {
        this.setState({picture: url});
      });
  }

  componentWillReceiveProps(newProps) {

    if (newProps.pckage.id !== this.props.pckage.id) {
      lh.models.asset.methods.getPosterUrl(newProps.pckage, {
        crop: {x: 132, y: 132},
        cache: false
      })
        .then((url) => {
          this.setState({picture: url});
        });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return _get(this.props, 'pckage.id') !== _get(nextProps, 'pckage.id')
      || this.state.picture !== nextState.picture
      || this.props.isSelected !== nextState.isSelected
      || !_isEqual(_get(nextProps, 'pckage', null), _get(this.props, 'pckage', null));
  }

  render() {

    let PackageTileClass = ClassNames({
      'col-last': this.props['col'] === 8,
      'channel block-1 bg-black radius showcase-row-channel-block': true
    });

    let lock = '';
    if (!this.props.pckage.is_purchased && !this.props.pckage.is_available && !this.props.pckage.is_free) {

      lock = <div className="lock">
        <i className="ic ic-lock ic-16px"></i>
      </div>;
    }

    let love = '';
    if (this.props.pckage.is_favorite) {
      love = <div className="love">
        <i className="ic ic-fav-in-fill ic-16px"></i>
      </div>;
    }

    return (
      <div className={PackageTileClass} onClick={this.props.onPackageSelect.bind(this, this.props.pckage, this.props.row, this.props.col)}>
        <a className="channel-link profile-show col hover">
          {this.props.isSelected && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
            <i className="ic ic-selected-dot ic-14px asset-selected-icon"></i>
          </ReactCSSTransitionGroup>}
          <div className="channel-poster">
            <img src={this.state.picture} alt={this.props.pckage.title} />
          </div>
          <span className="block-note" style={{bottom: '2px', left: '5px', paddingRight: '25px'}}>{this.props.pckage.title}</span>

          {lock}
          {love}
        </a>
      </div>
    );
  }
}

PackageTile.propTypes = {
  pckage: PropTypes.object.isRequired,
  onPackageSelect: PropTypes.func.isRequired
};

export default PackageTile;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Tile/Package/package-tile.js